import AsyncSelect from 'react-select/async';
import { useState, useEffect } from 'react';
const cx = require('classnames');

const AsyncSelectContainer = (props) => {
    
    const [value, setValue] = useState(null);
    const onChange = props.onChange || (() => {});
    const errormsg = props.error || false;
    const label = props.label || '';
    const id = props.id || 'id_select_'+label.replace(/[^A-Za-z0-9-_]/g, '');
    const loadOptions = props.loadOptions;
    const isDisabled = props.disabled || false;
    const isClearable = props.isClearable || false;
    const placeholder = props.placeholder || '';
    const defaultOptions = props.defaultOptions;
    const options = props.options || [];

    useEffect(() => {
        // Find the current value in the options when they change
        if (props.value && loadOptions) {
            // For async selects, we need to load the specific option to display the current value
            loadOptions('').then(allOptions => {
                const foundValue = allOptions.find(opt => opt.value == props.value);
                if (foundValue) {
                    setValue(foundValue);
                }
            });
        }
    }, [props.value, loadOptions]);

    const handleChange = (selectedOptions) => {
        setValue(selectedOptions);
        if (Array.isArray(selectedOptions)) {
            onChange(props.id, selectedOptions.map(option => option.value));
        } else {
            onChange(props.id, selectedOptions?.value);
        }
    };

    return (
         <div className={ cx('form-group', { 'has-error': !!errormsg }) }>
            <label className={ cx(props.className) } htmlFor={ id }>{ label }</label>
            <div className={ cx('col-sm-10 input-group') }>
                <AsyncSelect
                    id={id}
                    options={options}
                    value={value}
                    onChange={handleChange}
                    loadOptions={loadOptions}
                    defaultOptions={defaultOptions}
                    cacheOptions={false}
                    isMulti={props.isMulti}
                    isLoading={false}
                    isClearable={isClearable}
                    isDisabled={isDisabled}
                    placeholder={placeholder}
                    styles={{
                        // Fixes the overlapping problem of the component
                        menu: provided => ({ ...provided, zIndex: 3 })
                    }}
                />
            </div>
        </div>
    );
};

export default AsyncSelectContainer;
